export default "__VITE_ASSET__Cxtf9Qng__"